import state from './listingState';
import ApiListing from './apiListing';

export default {
    namespaced: true,
    state() {
        return {
            metaUrl: 'ocr/pur-invoice/metas',
            permissions: {
                create_payment: false,
            },
            metadatas: {},
            linkedtype: null,
            linkedid: null,
            isMultiple: false,
        };
    },
    mutations: {
        setAjax(state, xhttpRequest) {
            state.ajax = xhttpRequest;
        },
        updatePermissions(state, permissions) {
            state.permissions = permissions;
        },
        setLinkedtype: (state, linkedtype) => (state.linkedtype = linkedtype),
        setLinkedid: (state, linkedid) => (state.linkedid = linkedid),
        setIsMultiple: (state, isMultiple) => (state.isMultiple = isMultiple),
    },
    getters: {
        permissions(state) {
            return state.permissions || {};
        },
        getLinkedtype: (state) => state.linkedtype,
        getLinkedid: (state) => state.linkedid,
        getIsMultiple: (state) => state.isMultiple,
    },
    actions: {
        async init({ dispatch }) {
            await dispatch('loadMeta');
        },
        loadMeta({ state, commit }) {
            if (state.metaUrl === null) {
                return Promise.resolve();
            }
            return new Promise((resolve, reject) => {
                commit(
                    'setAjax',
                    ApiClient.get(state.metaUrl)
                        .then(function (response) {
                            try {
                                const permissions = response.data;

                                if (typeof permissions === 'object') {
                                    commit(
                                        'updatePermissions',
                                        Object.assign(state.permissions, permissions),
                                    );
                                }
                                resolve(permissions);
                            } catch (e) {
                                reject(e);
                            }
                        })
                        .catch(function () {
                            reject();
                            commit('setAjax', false);
                        }),
                );
            });
        },
        updateDataAfterSubmit({ commit }, { linkedtype, linkedid, isMultiple }) {
            commit('setLinkedtype', linkedtype);
            commit('setLinkedid', linkedid);
            commit('setIsMultiple', isMultiple);
        },
    },
};
